/**
 * @license lucide-vue-next v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const Tally1 = createLucideIcon("tally-1", [["path", { d: "M4 4v16", key: "6qkkli" }]]);

export { Tally1 as default };
//# sourceMappingURL=tally-1.js.map
